import { useEffect, useState } from 'react'

import { getTermTrends } from '_services/data-explorer'
import { logErrorAsync } from '_lib/utility'

export default function useTrends(requestConfig) {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const { lookback, terms } = requestConfig

    async function fetchData() {
      setLoading(true)

      try {
        const response = await getTermTrends(requestConfig)
        // const sortedResult = terms.reduce((obj, d) => ({ ...obj, [d]: response[d] }), {})
        const sortedResult = response

        setLoading(false)
        setData(sortedResult)
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }

      setLoading(false)
    }

    setData([])
    if (terms !== undefined && lookback && terms.length > 0) {
      fetchData()
    }
  }, [requestConfig])

  return { data, loading }
}
